import { render, staticRenderFns } from "./EndOutro.vue?vue&type=template&id=54218a76&"
import script from "./EndOutro.vue?vue&type=script&lang=js&"
export * from "./EndOutro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports